import { TFunction } from 'i18next';
import { TaskTimelineFrameEnum } from 'graphql-common';
import Select from '@lib/components/Select/Select';
import SiteOption from '@lib/components/Select/components/SiteOption';
import { GetLoadOptions } from '@lib/components/Select/types';
import { FieldChangeCallBackArgs } from '@lib/interfaces/form';
import TasksFilterFieldNames from '@lib/enums/fieldNames/tasksFilterFieldNames';
import getValidityHintOptions from 'components/FormTemplateBuilder/utils/getValidityHintOptions';
import { getOptionsArrayValidation } from '@lib/utils/validationUtils';

export const TASKS_TIMELINE_FILTER_EMPTY_VALUES = {
  [TasksFilterFieldNames.Site]: undefined,
  [TasksFilterFieldNames.FormCategory]: undefined,
  [TasksFilterFieldNames.ValidityHints]: undefined,
  [TasksFilterFieldNames.Period]: undefined,
  [TasksFilterFieldNames.TimelineEndDate]: undefined,
  [TasksFilterFieldNames.TimelineView]: TaskTimelineFrameEnum.Week,
};

type Args = {
  getFormCategoriesLoadOptions: GetLoadOptions;
  getSitesLoadOptions: GetLoadOptions;
  t: TFunction<'translation', undefined>;
};

export default function useFilterFields(args: Args) {
  const { getFormCategoriesLoadOptions, getSitesLoadOptions, t } = args;
  return [
    {
      name: TasksFilterFieldNames.Site,
      label: t('sites-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        defaultOptions: true,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getSitesLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
        components: {
          Option: SiteOption,
        },
      },
      fieldChangeCallBack: ({
        type,
        setValue,
        name,
      }: FieldChangeCallBackArgs) => {
        if (type === 'change' && name === TasksFilterFieldNames.Site) {
          setValue(TasksFilterFieldNames.SiteArea, null, {
            shouldValidate: true,
          });
          setValue(TasksFilterFieldNames.Asset, null, { shouldValidate: true });
        }
      },
      isOptionalFn: () => false,
    },
    {
      name: TasksFilterFieldNames.FormCategory,
      label: t('form-categories-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        defaultOptions: true,
        isAsync: true,
        isMulti: true,
        getLoadOptions: getFormCategoriesLoadOptions,
        maxMenuHeight: 200,
        usePortal: true,
      },
      isOptionalFn: () => false,
    },
    {
      name: TasksFilterFieldNames.ValidityHints,
      label: t('completion-statuses-label'),
      element: Select,
      validation: getOptionsArrayValidation({ t }),
      componentProps: {
        isSearchable: false,
        isMulti: true,
        options: getValidityHintOptions(),
        menuPlacement: 'top',
        usePortal: true,
      },
      isOptionalFn: () => false,
    },
  ];
}
